export const environment = {
    production: false,
    apiUrl: 'https://casosback.rauldev.cl',
    panelUrl: '',
    refreshCooldownSeconds: 3600,
    // URL externa del botón "Claudera" (se abre en pestaña nueva). Reemplazar por la real.
    clauderaUrl: 'https://claude.ai'
  };
